import {
  createAction,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";

import type { RootState } from "../root/config.store";
import {
  type OrderDetailsList,
  DraftOrderPayload,
  initialState,
} from "../../types/draftOrder";

// slice
export const draftOrderSlice = createSlice({
  name: "draftOrderList",
  initialState,
  reducers: {
    fetchAllisLoading(state) {
      state.loading = true;
      state.success = false;
    },
    fetchAllSucceeded(state, action: PayloadAction<OrderDetailsList>) {
      state.data = action.payload;
      state.loading = false;
      state.success = false;
    },
    fetchAllFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteOrderRequest(state, action: PayloadAction<number>) {
      state.loading = true;
    },
    deleteOrderSuccess(state, action: PayloadAction<number>) {
      state.loading = false;
      state.data.orderList = state.data.orderList.filter(
        (order) => order.orderId !== action.payload
      );
      state.success = true;
    },
    deleteOrderFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
  },
});

// Actions
export const draftOrderActions = {
  fetchAll: createAction<DraftOrderPayload>(`${draftOrderSlice.name}/fetchAll`),
  fetchAllisLoading: draftOrderSlice.actions.fetchAllisLoading,
  fetchAllSucceeded: draftOrderSlice.actions.fetchAllSucceeded,
  fetchAllFailure: draftOrderSlice.actions.fetchAllFailure,
  deleteOrderRequest: draftOrderSlice.actions.deleteOrderRequest,
  deleteOrderSuccess: draftOrderSlice.actions.deleteOrderSuccess,
  deleteOrderFailure: draftOrderSlice.actions.deleteOrderFailure,
};

// Selectors
export const draftOrder = (state: RootState): OrderDetailsList =>
  state.draftOrderList?.data ?? [];

// Reducer
export default draftOrderSlice.reducer;
